import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon, ShieldCheckIcon, LockIcon, UserIcon } from 'lucide-react';
import { TwoFactorAuth } from './TwoFactorAuth';
import { DEMO_USERS, User } from '../../types/auth';
export const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showTwoFactor, setShowTwoFactor] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    // Validate form
    if (!username || !password) {
      setError('Semua bidang harus diisi');
      return;
    }
    // Check if user exists in DEMO_USERS
    const user = DEMO_USERS.find(u => u.username === username && password === 'password123');
    // For demo purposes, we'll allow any login if it matches a demo user OR if it's a manual entry
    // In a real app, we'd validate against a backend
    const matchedUser = user || DEMO_USERS.find(u => u.username === username);
    if (matchedUser) {
      setSelectedUser(matchedUser);
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        setShowTwoFactor(true);
      }, 1500);
    } else {
      // Allow generic login for testing if not in demo list, default to user role
      const genericUser: User = {
        username,
        role: 'user',
        name: 'Pengguna Tamu',
        unit: 'Umum'
      };
      setSelectedUser(genericUser);
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        setShowTwoFactor(true);
      }, 1500);
    }
  };
  const handleTwoFactorSuccess = () => {
    if (selectedUser) {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('userRole', selectedUser.role);
      localStorage.setItem('userName', selectedUser.name);
      localStorage.setItem('userUnit', selectedUser.unit);
      // Force full page reload so AppRouter re-reads auth state from localStorage
      window.location.href = '/';
    }
  };
  const handleDemoLogin = (user: User) => {
    setUsername(user.username);
    setPassword('password123'); // Auto-fill password
    setError('');
  };
  if (showTwoFactor) {
    return <TwoFactorAuth onSuccess={handleTwoFactorSuccess} username={username} data-id="element-61" />;
  }
  return <div className="min-h-screen flex flex-col bg-dark-900 font-sans" data-id="element-62">
      {/* Top security banner */}
      <div className="bg-accent-red py-1 text-center shadow-md z-10 relative" data-id="element-63">
        <div className="flex items-center justify-center space-x-2" data-id="element-64">
          <div className="w-2 h-2 bg-white rounded-full animate-pulse" data-id="element-65"></div>
          <p className="text-xs font-bold tracking-wider text-white uppercase" data-id="element-66">
            SISTEM TERKLASIFIKASI - AKSES TERBATAS
          </p>
          <div className="w-2 h-2 bg-white rounded-full animate-pulse" data-id="element-67"></div>
        </div>
      </div>
      <div className="flex-1 flex flex-col lg:flex-row" data-id="element-68">
        {/* Left side - decorative */}
        <div className="hidden lg:flex lg:w-1/2 bg-gradient-intelligence relative overflow-hidden items-center justify-center p-12" data-id="element-69">
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-pattern-grid opacity-5" data-id="element-70"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-dark-900/50 to-dark-900/80" data-id="element-71"></div>

          <div className="max-w-md relative z-10" data-id="element-72">
            <div className="mb-8 flex justify-center" data-id="element-73">
              <div className="relative" data-id="element-74">
                <div className="absolute inset-0 bg-primary blur-3xl opacity-20 rounded-full" data-id="element-75"></div>
                <img src="https://cdn.magicpatterns.com/uploads/hFLsea95KTbfu8th3Tcctj/logo-BIN-NEW.png" alt="BIN Logo" className="h-40 relative z-10 drop-shadow-2xl" data-id="element-76" />
              </div>
            </div>
            <h1 className="text-5xl font-bold text-white mb-2 text-center tracking-tight" data-id="element-77">
              ARSENA
            </h1>
            <div className="h-1 w-24 bg-primary mx-auto mb-6 rounded-full" data-id="element-78"></div>
            <h2 className="text-xl font-medium text-primary-light mb-2 text-center tracking-wide" data-id="element-79">
              Asset Resource Strategic Enterprise Network for
              Advanced-Technology
            </h2>
            <p className="text-blue-200/60 text-center mb-10 text-sm leading-relaxed font-light" data-id="element-80">
              Sistem Manajemen Aset dan Sumber Daya Teknologi Strategis
              <br data-id="element-81" />
              Badan Intelijen Negara Republik Indonesia
            </p>
            <div className="space-y-4" data-id="element-82">
              <div className="flex items-start space-x-4 text-gray-300 p-4 rounded-lg bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300" data-id="element-83">
                <div className="p-2 rounded-lg bg-dark-800 border border-dark-600 shadow-lg" data-id="element-84">
                  <ShieldCheckIcon className="h-6 w-6 text-primary" data-id="element-85" />
                </div>
                <div data-id="element-86">
                  <h3 className="font-bold text-white text-sm mb-1" data-id="element-87">
                    Keamanan Berlapis
                  </h3>
                  <p className="text-xs text-gray-400 leading-relaxed" data-id="element-88">
                    Autentikasi dua faktor, enkripsi end-to-end, dan pemantauan
                    anomali real-time.
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-4 text-gray-300 p-4 rounded-lg bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300" data-id="element-89">
                <div className="p-2 rounded-lg bg-dark-800 border border-dark-600 shadow-lg" data-id="element-90">
                  <LockIcon className="h-6 w-6 text-primary" data-id="element-91" />
                </div>
                <div data-id="element-92">
                  <h3 className="font-bold text-white text-sm mb-1" data-id="element-93">
                    Akses Terklasifikasi
                  </h3>
                  <p className="text-xs text-gray-400 leading-relaxed" data-id="element-94">
                    Pengelolaan aset negara dengan tingkat keamanan tinggi
                    sesuai standar intelijen.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Right side - login form */}
        <div className="flex-1 flex items-center justify-center p-6 bg-dark-800 relative" data-id="element-95">
          <div className="absolute inset-0 bg-pattern-grid opacity-[0.03] pointer-events-none" data-id="element-96"></div>
          <div className="w-full max-w-md relative z-10" data-id="element-97">
            <div className="lg:hidden mb-8 flex flex-col items-center" data-id="element-98">
              <img src="https://cdn.magicpatterns.com/uploads/hFLsea95KTbfu8th3Tcctj/logo-BIN-NEW.png" alt="BIN Logo" className="h-24 mb-4 drop-shadow-lg" data-id="element-99" />
              <h1 className="text-3xl font-bold text-white text-center mb-1" data-id="element-100">
                ARSENA
              </h1>
              <div className="h-0.5 w-16 bg-primary mx-auto mb-3 rounded-full" data-id="element-101"></div>
              <h2 className="text-sm font-medium text-primary mb-1 text-center" data-id="element-102">
                Asset Resource Strategic Enterprise Network for
                Advanced-Technology
              </h2>
              <p className="text-blue-300/60 text-[11px] text-center leading-relaxed mt-1" data-id="element-103">
                Sistem Manajemen Aset dan Sumber Daya Teknologi Strategis BIN RI
              </p>
            </div>
            <div className="bg-dark-700/80 backdrop-blur-md rounded-xl shadow-2xl p-8 border border-dark-600 mb-6 relative overflow-hidden" data-id="element-104">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary via-primary-light to-primary" data-id="element-105"></div>
              <h2 className="text-xl font-bold text-white mb-6 flex items-center" data-id="element-106">
                <UserIcon className="w-5 h-5 mr-2 text-primary" data-id="element-107" />
                Masuk ke Sistem
              </h2>
              {error && <div className="mb-6 bg-red-900/20 border-l-4 border-red-500 text-red-200 px-4 py-3 rounded-r text-sm flex items-start" data-id="element-108">
                  <div className="mr-2 mt-0.5 text-red-500" data-id="element-109">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" data-id="element-110">
                      <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" data-id="element-111" />
                    </svg>
                  </div>
                  {error}
                </div>}
              <form onSubmit={handleSubmit} data-id="element-112">
                <div className="space-y-5" data-id="element-113">
                  <div data-id="element-114">
                    <label htmlFor="username" className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5" data-id="element-115">
                      Username
                    </label>
                    <input id="username" type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full px-4 py-3 bg-dark-900/50 border border-dark-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary text-white placeholder-gray-600 transition-all duration-200" placeholder="Masukkan username" data-id="element-116" />
                  </div>
                  <div data-id="element-117">
                    <label htmlFor="password" className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5" data-id="element-118">
                      Password
                    </label>
                    <div className="relative" data-id="element-119">
                      <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 bg-dark-900/50 border border-dark-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary text-white placeholder-gray-600 pr-10 transition-all duration-200" placeholder="Masukkan password" data-id="element-120" />
                      <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-primary transition-colors" onClick={() => setShowPassword(!showPassword)} data-id="element-121">
                        {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-122" /> : <EyeIcon className="h-5 w-5" data-id="element-123" />}
                      </button>
                    </div>
                  </div>
                  <div className="flex items-center justify-between pt-2" data-id="element-124">
                    <div className="flex items-center" data-id="element-125">
                      <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 bg-dark-900 border-dark-500 rounded text-primary focus:ring-primary/50 focus:ring-offset-0 focus:ring-offset-transparent" data-id="element-126" />
                      <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-400 hover:text-gray-300 cursor-pointer transition-colors" data-id="element-127">
                        Ingat saya
                      </label>
                    </div>
                    <div className="text-sm" data-id="element-128">
                      <a href="#" className="font-medium text-primary hover:text-primary-light transition-colors text-xs uppercase tracking-wide" data-id="element-129">
                        Lupa password?
                      </a>
                    </div>
                  </div>
                  <div className="pt-2" data-id="element-130">
                    <button type="submit" disabled={isLoading} className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-lg shadow-primary/10 text-sm font-bold text-dark-900 bg-gradient-to-r from-primary to-primary-light hover:to-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark-800 focus:ring-primary transition-all duration-300 transform hover:-translate-y-0.5" data-id="element-131">
                      {isLoading ? <div className="flex items-center" data-id="element-132">
                          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-dark-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-133">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-134"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-135"></path>
                          </svg>
                          MEMPROSES...
                        </div> : 'MASUK KE SISTEM'}
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <p className="text-center text-xs text-gray-500 mb-8 max-w-xs mx-auto leading-relaxed" data-id="element-136">
              Sistem ini diawasi dan dimonitor 24/7. Penggunaan tidak sah akan
              ditindak tegas sesuai hukum yang berlaku.
            </p>

            {/* Demo Users Section */}
            <div className="border-t border-dark-600 pt-6" data-id="element-137">
              <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-4 text-center" data-id="element-138">
                Akses Cepat (Demo)
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-139">
                {DEMO_USERS.map(user => <button key={user.username} onClick={() => handleDemoLogin(user)} className="flex items-center p-3 bg-dark-700/50 hover:bg-dark-600 border border-dark-600 hover:border-dark-500 rounded-lg transition-all duration-200 text-left group hover:shadow-md" data-id="element-140">
                    <div className={`p-2 rounded-md mr-3 transition-colors ${user.role === 'super_admin' ? 'bg-primary/10 text-primary group-hover:bg-primary group-hover:text-dark-900' : user.role === 'admin_deputi' ? 'bg-blue-500/10 text-blue-400 group-hover:bg-blue-500 group-hover:text-white' : user.role === 'admin_stin' ? 'bg-purple-500/10 text-purple-400 group-hover:bg-purple-500 group-hover:text-white' : user.role === 'admin_binda' ? 'bg-green-500/10 text-green-400 group-hover:bg-green-500 group-hover:text-white' : user.role === 'auditor' ? 'bg-red-500/10 text-red-400 group-hover:bg-red-500 group-hover:text-white' : 'bg-gray-500/10 text-gray-400 group-hover:bg-gray-500 group-hover:text-white'}`} data-id="element-141">
                      <UserIcon size={16} data-id="element-142" />
                    </div>
                    <div className="overflow-hidden" data-id="element-143">
                      <p className="text-xs font-bold text-gray-200 truncate group-hover:text-white transition-colors" data-id="element-144">
                        {user.name}
                      </p>
                      <p className="text-[10px] text-gray-500 truncate group-hover:text-gray-300 transition-colors" data-id="element-145">
                        {user.unit} • {user.role.replace('_', ' ')}
                      </p>
                    </div>
                  </button>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <div className="py-3 px-6 bg-dark-950 border-t border-dark-800" data-id="element-146">
        <div className="flex flex-col sm:flex-row justify-between items-center max-w-7xl mx-auto text-xs text-gray-600" data-id="element-147">
          <div data-id="element-148">
            &copy; {new Date().getFullYear()} Badan Intelijen Negara Republik
            Indonesia.
          </div>
          <div className="flex space-x-4 mt-2 sm:mt-0" data-id="element-149">
            <span className="hover:text-gray-400 cursor-pointer transition-colors" data-id="element-150">
              Kebijakan Privasi
            </span>
            <span className="hover:text-gray-400 cursor-pointer transition-colors" data-id="element-151">
              Syarat Penggunaan
            </span>
            <span className="hover:text-gray-400 cursor-pointer transition-colors" data-id="element-152">
              Bantuan Teknis
            </span>
          </div>
        </div>
      </div>
    </div>;
};